<template>
  <footer class="footer">
    <div class="topArea">
      <div class="linkGroup">
        <a class="links" @click="$router.push('/companyProduce')">회사소개</a>
        <a class="links" @click="$router.push('/serviceTerms')">이용약관</a>
        <a class="links bold" @click="$router.push('/privacyPolicy')">개인정보처리방침</a>
        <a class="links" @click="$router.push('/partnershipInquery')">제휴문의</a>
        <a class="links" @click="$router.push('/b2BRentalInquery')">B2B렌탈문의</a>
      </div>
    </div>

    <div class="bottomArea">
      <div class="contact">
        <a class="links arrow tit" @click="$router.push('/customerCenter')">고객센터</a>
        <p class="tel RobotoB" @click="tel">1670-0202</p>
        <div class="txtItem">
          <span>평일 AM 09:00 ~ PM 06:00</span>
          <span>토, 일요일 및 공휴일 휴무</span>
        </div>
      </div>

      <div class="snsGroup">
        <a class="snsBtn_fb" target="_blank" @click="goUrl('facebook')"><i class="blind">페이스북</i></a>
        <a class="snsBtn_in" target="_blank" @click="goUrl('instagram')"><i class="blind">인스타그램</i></a>
        <a class="snsBtn_bl" target="_blank" @click="goUrl('blog')"><i class="blind">블로그</i></a>
        <a class="snsBtn_yt" target="_blank" @click="goUrl('youtube')"><i class="blind">유튜브채널</i></a>
      </div>

      <div class="company">
        <div class="txtItem">
          <span>상호명 : 웰릭스렌탈(주)</span>
          <span>대표이사 : 이창영</span>
        </div>
        <address>서울특별시 구로구 디지털로26길 123 (2층 209호 ,210호)</address>
        <p>
          사업자등록번호 : 773-81-00581
          <a @click="goTerms()" class="links underline">사업자정보확인</a>
        </p>
        <p>통신판매업 신고 : 제2023-서울용산-1540호</p>
        <p>
          개인정보보호책임자 : 이창영 (
          <!-- <a href="mailto:cs@welrixrental.co.kr">cs@welrixrental.co.kr</a> -->
          <a>cs@welrixrental.co.kr</a>
          )
        </p>
        <div class="txtItem">
          <span>팩스 : 02-852-6500</span>
          <span>
            이메일 :
            <!-- <a href="mailto:cs@welrixrental.co.kr">cs@welrixrental.co.kr</a> -->
            <a>cs@welrixrental.co.kr</a>
          </span>
        </div>
      </div>

      <div class="copyright">
        <p>Copyright ©WELRIX RENTAL. All rights reserved.</p>
      </div>

      <div class="fSite sltWrap">
        <div class="sltBtn">
          <span>패밀리 사이트</span>
          <button type="button" aria-label="목록 열기"></button>
        </div>
        <div class="sltMenu">
          <ul class="menu">
            <li>
              <a @click="goFamily('welcomefg')" target="_blank">웰컴금융그룹</a>
            </li>
            <li>
              <a @click="goFamily('welcomebank')" target="_blank">웰컴저축은행</a>
            </li>
            <!-- <li>  
              <a @click="goFamily('welcomeloan')" target="_blank">웰컴론</a>
            </li>
            <li>
              <a @click="goFamily('anyonecapital')" target="_blank">애니원론</a>
            </li> -->
            <li>
              <a @click="goFamily('welrixfni')" target="_blank">웰릭스 F&I</a>
            </li>
            <li>
              <a @click="goFamily('welcomepayments')" target="_blank">웰컴페이먼츠</a>
            </li>
            <li>
              <a @click="goFamily('welcomefinanceph')" target="_blank">WELCOME FINANCE INC,</a>
            </li>
            <li>
              <a @click="goFamily('laos')" target="_blank">WELCOME LEASING LAO</a>
            </li>
            <li>
              <a @click="goFamily('welcomebankph')" target="_blank">WELCOME BANK(Rural Bank)</a>
            </li>
            <li>
              <a @click="goFamily('kh')" target="_blank">Welcome Finance Cambodia</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import ApiService from '@/common/api.service';
import * as customjs from '@/../static/js/m.front';

export default {
  name: 'Footer',
  mounted() {
    customjs.sltInit();
  },
  methods: {
    goUrl(target) {
      let url = '';
      if (target == 'facebook') url = 'https://www.facebook.com/welrix.official/';
      else if (target == 'instagram') url = 'https://www.instagram.com/welrix.official/';
      else if (target == 'blog') url = 'https://m.blog.naver.com/welrix01';
      else if (target == 'youtube') url = 'https://www.youtube.com/channel/UC-pMiQm4S6KYt6fDMEzWnLg';
      window.location.href = url;
    },
    goFamily(target) {
      let url = '';
      if (target == 'welcomefg') url = 'http://www.welcomefg.co.kr/home/main/index';
      else if (target == 'welcomebank') url = 'https://m.welcomebank.co.kr/ib20/mnu/MWB000000000';
      else if (target == 'welcomeloan') url = 'https://www.welcomeloan.co.kr/';
      else if (target == 'anyonecapital') url = 'https://www.anyonecapital.co.kr/gate/main.do';
      else if (target == 'welrixfni') url = 'https://www.welrixfni.com/main/main.jsp';
      else if (target == 'welcomepayments') url = 'https://www.welcomepayments.co.kr/';
      else if (target == 'welcomefinanceph') url = 'https://welcomefinanceph.com/';
      else if (target == 'welcomebankph') url = 'http://www.welcomebank.com.ph/';
      else if (target == 'laos') url = 'https://laos.welcomefg.co.kr/main.do';
      else if (target == 'kh') url = 'https://welcomefinance.com.kh/km/main';

      window.location.href = url;
    },
    goTerms() {
      window.location.href = 'http://www.ftc.go.kr/bizCommPop.do?wrkr_no=773-81-00581&apv_perm_no=';
    },
    tel() {
      ApiService.service('GET', '/common/businesshours')
        .then(({ data }) => {
          if (data.isSucceed) {
            if (data.result.businessHourYn == 'Y') window.tel('16700202');
            else this.$router.push('/callService');
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
  },
};
</script>
